import React from 'react';
import PropTypes from 'prop-types';

export function Icon(props) {
    return <span {...props} className={`odf-icon odf-icon-${props.glyph} ${props.className}`} />;
}

Icon.propTypes = {
    glyph: PropTypes.string.isRequired,
    className: PropTypes.string,
    style: PropTypes.object,
};

Icon.defaultProps = {
    className: '',
    style: {},
};
